<template>
  <div class="store-control flex--col-center-start">
    <div class="flex--row-start-center" @click="changeLocale">
      <Globe
        class="store-control__globe-icon"
        :class="{ 'store-control__globe-icon--root': root }"
        :style="{ stroke: uiColor }"
      ></Globe>
      <!-- <v-select
        class="store-control__select"
        :class="{ 'store-control__select--root': root }"
        :options="getRegionOptions"
        :value="activeCountryCode"
        :clearable="false"
        :searchable="false"
        :selectable="option => option.noSelect != true"
        @input="changeLocale"
      >
        <template #selected-option="{ name }">
          <span
            class="text-body-small text--uppercase"
            :style="{ color: uiColor }"
          >
            {{ name }}
          </span>
        </template>
        <template #option="{ name }">
          <span class="text-body-small text--uppercase">
            {{ name }}
          </span>
        </template>
      </v-select> -->
      <!-- <v-select
        class="store-control__select store-control__select--language"
        :class="{ 'store-control__select--root': root }"
        v-if="getLanguageOptions.length > 0"
        :options="getLanguageOptions"
        :clearable="false"
        :value="activeLanguage"
        @input="changeLanguage"
      >
        <template #selected-option="{ label }">
          <span class="text-body" :style="{ color: uiColor }">
            {{ languageOptions[label] }}
          </span>
        </template>
        <template #option="{ label }">
          <span class="text-body">
            {{ languageOptions[label] }}
          </span>
        </template>
      </v-select> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex"
import { languageOptions } from "@/store/constants"
import LocaleSelectorModal from "@/modules/Modals/LocaleSelectorModal"

import Globe from "@/assets/globe.svg"

import styles from "@/styles/settings.module.scss"

// import Chevron from "@/assets/chevron-down.svg"

export default {
  data: () => ({
    activeCountryCode: null,
    activeLanguage: null,
    languageOptions
  }),

  components: {
    Globe
  },

  props: {
    uiColor: {
      type: String,
      default: styles["COLOUR_bleach_black"]
    },
    root: Boolean
  },

  // components: {
  //   Chevron
  // },

  mounted() {
    // this.initLocale()
  },

  methods: {
    ...mapActions("locale", ["CHANGE_LOCALE"]),

    initLocale() {
      this.activeCountryCode = this.getRegionOptions.find(
        regionOption =>
          regionOption.countryCode.toUpperCase() ==
          this.localeConfig.countryCode.toUpperCase()
      )
      // this.activeLanguage = this.getLanguageOptions.find(
      //   languageOption => languageOption == this.GET_ACTIVE_LANGUAGE
      // )
    },

    // changeLanguage(language) {
    //   this.CHANGE_LOCALE({
    //     countryCode: this.activeCountryCode,
    //     language
    //   })
    // },

    changeLocale() {
      Bleach.debug.log("changeLocale")
      this.$modal_container
        .launch(LocaleSelectorModal, {
          props: {
            /* targetCountryCode: evt.countryCode,
            context: "user" */
          },
          priority: false
        })
        .catch(() => {
          // if the store change is rejected in the modal
          this.initLocale()
        })
    }
  },

  computed: {
    ...mapState("locale", ["localeOptions", "localeConfig"]),
    ...mapGetters("locale", ["GET_REGION_OPTIONS", "GET_ACTIVE_LANGUAGE"]),

    // getLanguageOptions() {
    //   let _languages = []

    //   // if the locale has a language
    //   const _localeSpecificLanguage = this.activeLocale.market.locales.find(
    //     locale => locale.code == this.activeLocale.locale
    //   )?.language
    //   if (_localeSpecificLanguage) {
    //     _languages.push(_localeSpecificLanguage)
    //     _languages.push(this.activeLocale.market.defaultLanguage)
    //   }

    //   return _languages
    // },

    getRegionOptions() {
      return this.GET_REGION_OPTIONS.map(({ countryCode, name }) => {
        return {
          countryCode,
          name,
          label: countryCode
        }
      })
    }
  },

  watch: {
    GET_REGION_OPTIONS: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.initLocale()
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss">
$stroke-width: 1px;

.store-control {
  cursor: pointer;
  position: relative;
  pointer-events: all;

  &__select {
    &.v-select {
      width: 200px;

      .vs__dropdown-toggle {
        border: unset;
        border-radius: unset;
      }

      .vs__selected-options {
        padding: 0 12px;
        // opacity: 0;
      }

      .vs__selected {
        border: unset;
        border-radius: unset;
        line-height: unset;
        margin: 0;
        padding: 0;
      }

      .vs__search {
        padding: unset;
        margin: unset;
      }

      .vs__dropdown-option {
        padding: 4px 12px;
      }
    }

    &--language {
      &.v-select {
        width: 200px;
      }
    }

    &--root {
      &.v-select {
        .vs__dropdown-toggle {
          opacity: 0;
        }
      }
    }
  }

  &__globe-icon {
    height: 22px;

    path,
    circle,
    ellipse {
      stroke: inherit;
      fill: none;
      stroke-width: $stroke-width;
      vector-effect: non-scaling-stroke;
    }

    @include media-breakpoint-up(xl) {
      height: 26px;
    }

    &--root {
      opacity: 0;
    }
  }
}
</style>
